import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out-modal.component.html',
  styleUrls: ['./sign-out-modal.component.scss'],
  standalone: false,
})
export class SignOutModalComponent implements OnInit {
  public isVisible: boolean = false;

  constructor(
    public router: Router,
    public translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.isVisible = false;
  }

  hideModal = () => {
    this.isVisible = false;
  };

  showModal = () => {
    this.isVisible = true;
  };

  showSignOut = () => {
    return this.isVisible;
  };

  signOut = () => {
    this.router.navigate(['/signout']);
  };
}
